import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Nav, Button, Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { setCurrentLanguage } from "../../store/translationSlice";
import { setLanguages } from "../../../../redux/slices/languageSlice";
import {
  FaTicketAlt,
  FaGlobe,
  FaRegCopyright,
  FaBars,
  FaSignInAlt,
  FaUserPlus,
  FaSignOutAlt,
  FaUsers,
  FaCog,
  FaUserCircle,
  FaChevronDown,
  FaTimes,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";
// import { loginSuccess } from '../../../../redux/slices/authSlice';
import { useTranslation } from "react-i18next";
import HeroSection from "../../../../components/HeroSection/HeroSection";
import lift14Img from "../../../../assets/lift14_2.svg";
import { API_END_POINTS } from "../../../../network/apiEndPoint";
import axios from "axios";
import { baseURL } from "../../../../network/baseUrl";

const HomePage = () => {
  const { i18n, t } = useTranslation();
  const location = useLocation();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  // const [navbarExpanded, setNavbarExpanded] = useState(false);
  const [isChangingPassword, setIsChangingPassword] = useState(false);

  const [isLoggedIn, setIsLoggedIn] = useState(false); // Track login state
  const [userRole, setUserRole] = useState(null); // Store user role
  const [dashboardName, setDashboardName] = useState("");
  const userDropdownRef = useRef(null);
  const userName = localStorage.getItem("name") || "User";
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const fullName = localStorage.getItem("name") || "User";
  const languageDropdownRef = useRef(null);
  const firstName = fullName.split(" ")[0];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordData, setPasswordData] = useState({
    oldPassword: "",
    newPassword: "",
    newPasswordConfirm: "",
  });

  const handleToggleLanguageDropdown = (e) => {
    e.stopPropagation();
    setIsLanguageDropdownOpen((prev) => !prev);
    setShowUserDropdown(false);
  };

  useEffect(() => {
    const currentLang = localStorage.getItem("selectedLanguage") || "en";
    dispatch(setLanguages(currentLang));
    // Check if user is logged in
    const accessToken = localStorage.getItem("access");
    const role = localStorage.getItem("userRole");
    if (accessToken) {
      setIsLoggedIn(true);
      setUserRole(role);
      // setDashboardName(getDashboardName(role));
    }
  }, []);

  const userProfile = {
    name: fullName,
    email: localStorage.getItem("userEmail"),
    role: (() => {
      const role = localStorage.getItem("userRole");
      switch (role) {
        case "admin":
          return "Administrator";
        case "asset_manager":
          return "Asset Manager";
        case "customer_manager":
          return "Customer Manager";
        case "warehouse_manager":
          return "Warehouse Manager";
        case "finance_manager":
          return "Finance Manager";
        default:
          return "User";
      }
    })(),
  };
  const handleLogout = () => {
    // Handle logout logic here
    localStorage.removeItem("access");
    localStorage.removeItem("userRole");
    localStorage.removeItem("name");
    localStorage.removeItem("userEmail");
    navigate("/login");
  };
  const getDashboardName = (role) => {
    switch (role) {
      case "admin":
        return t("dashboard.adminTitle");
      case "ticket_manager":
        return t("dashboard.ticket_managerTitle");
      case "customer_manager":
        return t("dashboard.customer_managerTitle");
      case "sales_manager":
        return t("dashboard.sales_managerTitle");
      case "user":
        return t("dashboard.userTitle");
      default:
        return t("dashboard.title");
    }
  };
  const handleLoginClick = () => {
    navigate("/login");
  };
  const handleToggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const handleRegisterClick = () => {
    navigate("/register");
  };

  const handleNavToggle = () => {
    // setNavbarExpanded(!navbarExpanded);
  };

  // const handleNavLinkClick = (path) => {
  //   navigate(path);
  //   setNavbarExpanded(false);
  // };
  const handleToggleUserDropdown = () => {
    setShowUserDropdown((prev) => !prev);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        userDropdownRef.current &&
        !userDropdownRef.current.contains(event.target)
      ) {
        setShowUserDropdown(false); // Close dropdown if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const handleClickOutsideMenu = (event) => {
      if (isMobileMenuOpen && !event.target.closest(".mobilenav")) {
        setIsMobileMenuOpen(false); // Close mobile menu
      }
    };

    document.addEventListener("mousedown", handleClickOutsideMenu);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideMenu);
    };
  }, [isMobileMenuOpen]);

  const handleTicketSystemClick = () => {
    if (!isLoggedIn) {
      toast.warn(t("toast.loginMessage"));
      return;
    }

    let targetRoute = "/dashboard"; // Default route
    switch (userRole) {
      case "admin":
        targetRoute = "/dashboard";
        break;
      case "customer_manager":
        targetRoute = "/dashboard";
        break;
      case "asset_manager":
        targetRoute = "/dashboard";
        break;
      case "warehouse_manager":
        targetRoute = "/dashboard";
        break;
      case "finance_manager":
        targetRoute = "/dashboard";
        break;
      default:
        break;
    }
    navigate(targetRoute);
  };

  const navbarTitle = (() => {
    switch (userRole) {
      case "admin":
        // return t('dashboard.adminTitle');
        return t("createAsset.buttons.M-Desk");
      case "ticket_manager":
        // return t('dashboard.ticket_managerTitle');
        return t("createAsset.buttons.M-Desk");
      case "customer_manager":
        // return t('dashboard.customer_managerTitle');
        return t("createAsset.buttons.M-Desk");
      case "sales_manager":
        // return t('dashboard.sales_managerTitle');
        return t("createAsset.buttons.M-Desk");
      case "user":
        // return t('dashboard.userTitle');
        return t("createAsset.buttons.M-Desk");
      default:
        // return t('dashboard.title');
        return t("createAsset.buttons.M-Desk");
    }
  })();

  const menuItems = [
    {
      label: t("createAsset.buttons.AssetSystem"),
      onClick: handleTicketSystemClick,
    },
    // { label: t("createAsset.buttons.HelpCenter") },
    {
      label: t("createAsset.buttons.contactus"),
      onClick: () => { console.log("button clicked") ;navigate("/contact"); }
    },

    // { label: t('createAsset.buttons.Knowledge') },
    // { label: t('createAsset.buttons.Marketing') },
    // { label: t("createAsset.buttons.Trucks") },
  ];

  const changeLanguage = async (lang) => {
    try {
      // Temporarily store current language
      const prevLang = i18n.language;

      // Only proceed if the selected language is different
      if (prevLang !== lang) {
        // Change the i18n language
        await i18n.changeLanguage(lang);
        localStorage.setItem("selectedLanguage", lang);
        dispatch(setCurrentLanguage(lang));
        // Close the dropdown
        dispatch(setCurrentLanguage(lang));
        setIsLanguageDropdownOpen(false);
      }
    } catch (error) {
      console.error("Language change failed:", error);
      alert("Failed to change language");
    }
  };
  const languages = [
    { code: "en", name: "English", flag: "🇬🇧" },
    { code: "de", name: "Deutsch", flag: "🇩🇪" },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        languageDropdownRef.current &&
        !languageDropdownRef.current.contains(event.target)
      ) {
        setIsLanguageDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const validatePassword = (password) => {
    const passwordCriteria =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordCriteria.test(password)) {
      return {
        isValid: false,
        message: t("loginToasters.passwordValidationMessage"),
      };
    }
    return { isValid: true };
  };

  const handleSubmitPasswordChange = async (e) => {
    e.preventDefault();

    // First check if new passwords match
    if (passwordData.newPassword !== passwordData.newPasswordConfirm) {
      toast.error(t("dashboardToasters.newAndOldPasswordNotMatch"), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
      return;
    }

    // Check if new password is same as current password
    if (passwordData.oldPassword === passwordData.newPassword) {
      toast.error(t("dashboardToasters.newAndOldPassCannotBeSame"), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
      return;
    }
    const passwordValidation = validatePassword(passwordData.newPassword);
    if (!passwordValidation.isValid) {
      toast.error(passwordValidation.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
      return;
    }

    setIsChangingPassword(true);
    const token = localStorage.getItem("access");

    try {
      const response = await axios.post(
        `${baseURL}/update-password/`,
        {
          old_password: passwordData.oldPassword,
          new_password: passwordData.newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        if (!toast.isActive("password-success")) {
          toast.success(t("dashboardToasters.passChangeSuccess"), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
            toastId: "password-success",
          });
        }
        setShowChangePasswordModal(false);
        setPasswordData({
          oldPassword: "",
          newPassword: "",
          newPasswordConfirm: "",
        });
      }
    } catch (error) {
      if (error.response) {
        // Check for incorrect current password error
        if (
          error.response.status === 400 &&
          error.response.data?.message
            ?.toLowerCase()
            .includes("current password")
        ) {
          toast.error(t("dashboardToasters.incorrectCurrPass"), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
        } else if (error.response.status === 401) {
          toast.error(t("dashboardToasters.sessionExpiration"), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
          navigate("/login");
        } else {
          // For any other error
          const errorMessage =
            t("dashboardToasters.incorrectCurrPass");
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
        }
      } else {
        toast.error(t("loginToasters.genericError"), {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
      }
      console.error("Error changing password:", error);
    } finally {
      setIsChangingPassword(false);
    }
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <header className="bg-[#1b1b1b] shadow-sm sticky top-0 z-50">
        {/* Desktop & Tablet Navigation */}
        <div className="hidden md:block">
          <div className="mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              {/* Logo and Title */}
              <Link
                to="/"
                className="flex items-center text-gray-300 hover:text-white transition-colors duration-200 shrink-0"
              >
                <span className="font-bold text-lg xl:text-xl">
                  <img
                    className="h-8 w-auto object-contain"
                    src={lift14Img}
                    alt="logo"
                  />
                </span>
              </Link>

              {/* Desktop Navigation */}
              <nav className="flex items-center space-x-4 md:space-x-6 lg:space-x-8">
                {/* Menu Items */}
                <div className="flex items-center space-x-3 md:space-x-4 lg:space-x-6">
                  {menuItems.map((item, index) => (
                    <div
                      key={index}
                      onClick={item.onClick}
                      className="cursor-pointer"
                    >
                      <span
                        className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 hover:bg-gray-700 hover:text-white ${location.pathname === item.path
                            ? "bg-gray-700 text-white"
                            : "text-gray-300"
                          }`}
                      >
                        {item.label}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Spacer */}
                <div className="hidden lg:block w-16 xl:w-32"></div>

                {/* Language Dropdown */}
                <div className="relative z-[100] language-dropdown-container">
                  {/* <FaSearch className='text-white h-4 w-4 '/> */}
                  <button
                    className="text-gray-300 hover:text-white p-2 rounded-full"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent event from bubbling
                      setIsLanguageDropdownOpen(!isLanguageDropdownOpen);
                    }}
                  >
                    <FaGlobe className="h-5 w-5" />
                  </button>

                  {isLanguageDropdownOpen && (
                    <div className="absolute right-0 mt-2 w-48 bg-gray-800  shadow-lg py-1 z-[60]">
                      {languages.map((lang) => (
                        <button
                          key={lang.code}
                          className={`w-full text-left px-4 py-2 text-sm z-[60] ${i18n.language === lang.code
                              ? "bg-gray-700 text-white"
                              : "text-gray-300 hover:bg-gray-700"
                            }`}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            changeLanguage(lang.code);
                          }}
                        >
                          <span className="mr-2 z-[60]">{lang.flag}</span>
                          <span>{lang.name}</span>
                          {i18n.language === lang.code && (
                            <span className="ml-2">✓</span>
                          )}
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                {/* User Section */}
                {isLoggedIn ? (
                  <div className="relative" ref={userDropdownRef}>
                    <button
                      className="flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-gray-700 px-3 py-2 rounded-md transition-colors duration-200"
                      onClick={handleToggleUserDropdown}
                    >
                      <FaUserCircle className="w-5 h-5" />
                      <span className="text-sm font-medium">{firstName}</span>
                      <FaChevronDown className="w-4 h-4" />
                    </button>

                    {showUserDropdown && (
                      <div className="absolute right-0 mt-2 w-72 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                        {/* Profile Header */}
                        <div className="px-4 py-3 border-b border-gray-200">
                          <div className="flex items-center">
                            <FaUserCircle className="w-10 h-10 text-gray-400" />
                            <div className="ml-3">
                              <div className="text-sm font-medium text-gray-900">
                                {userProfile.name}
                              </div>
                              <div className="text-sm text-gray-500">
                                {userProfile.role}
                              </div>
                              {userProfile.email && (
                                <div className="text-xs text-gray-400">
                                  {userProfile.email}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Menu Items */}
                        <div className="py-1">
                          {userRole === "admin" && (
                            <Link
                              to="/admin/users"
                              className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            >
                              <FaUsers className="w-4 h-4 mr-3" />
                              {t("navbar-profile.users")}
                            </Link>
                          )}
                          <button
                            onClick={() => setShowChangePasswordModal(true)}
                            className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                          >
                            <FaCog className="w-4 h-4 mr-3" />
                            {t("navbar.changePassword")}
                          </button>
                          <div className="border-t border-gray-200"></div>
                          <button
                            onClick={handleLogout}
                            className="w-full flex items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50"
                            disabled={isLoggingOut}
                          >
                            {isLoggingOut ? (
                              <>
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-red-600 mr-3"></div>
                                <span>{t("navbar.logout")}</span>
                              </>
                            ) : (
                              <>
                                <FaSignOutAlt className="w-4 h-4 mr-3" />
                                {t("navbar.logout")}
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="flex items-center space-x-3">
                    <button
                      className="px-4 py-2 text-sm font-medium text-gray-300 hover:text-white border border-gray-600 hover:border-gray-500 rounded-md transition-colors duration-200"
                      onClick={() => navigate("/login")}
                    >
                      {t("createAsset.buttons.Login")}
                    </button>
                    <button
                      className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors duration-200"
                      onClick={() => navigate("/register")}
                    >
                      {t("createAsset.buttons.Signup")}
                    </button>
                  </div>
                )}
              </nav>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className="md:hidden w-full">
          <div className="px-4 w-full">
            <div className="flex justify-between items-center h-16">
              <Link to="/" className="flex items-center">
                <span className="font-bold text-gray-300 text-lg">
                  <img
                    className="h-8 w-auto object-contain"
                    src={lift14Img}
                    alt="logo"
                  />
                </span>
              </Link>

              <button
                className="p-2 text-gray-300 hover:text-white transition-colors"
                onClick={handleToggleMobileMenu}
              >
                {isMobileMenuOpen ? (
                  <FaTimes className="w-6 h-6" />
                ) : (
                  <FaBars className="w-6 h-6" />
                )}
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <nav className="w-full bg-gray-800 px-4 pt-2 pb-4 shadow-md mobilenav">
              {menuItems.map((item, index) => (
                <div
                  key={index}
                  onClick={() => {
                    if (item.onClick) item.onClick();
                    setIsMobileMenuOpen(false);
                  }}
                  className="py-2 cursor-pointer"
                >
                  <span
                    className={`block text-gray-300 hover:text-white transition-colors ${location.pathname === item.path
                        ? "text-white font-medium"
                        : ""
                      }`}
                  >
                    {item.label}
                  </span>
                </div>
              ))}

              {/* Mobile Language Dropdown */}
              <div className="py-2" ref={languageDropdownRef}>
                <button
                  className="flex items-center text-gray-300 hover:text-white transition-colors"
                  onClick={handleToggleLanguageDropdown}
                >
                  <FaGlobe className="w-5 h-5 mr-2" />
                  <span>Language</span>
                </button>

                {isLanguageDropdownOpen && (
                  <div className="mt-2 bg-gray-700  w-full">
                    {languages.map((lang) => (
                      <button
                        key={lang.code}
                        className={`w-full text-left px-4 py-2 flex items-center justify-between text-sm text-gray-300 hover:bg-gray-600 ${i18n.language === lang.code ? "bg-gray-600" : ""
                          }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          changeLanguage(lang.code);
                        }}
                      >
                        <div className="flex items-center">
                          <span className="mr-2">{lang.flag}</span>
                          <span>{lang.name}</span>
                        </div>
                        {i18n.language === lang.code && (
                          <span className="text-green-500">✓</span>
                        )}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Mobile User Menu / Login Buttons */}
              {isLoggedIn ? (
                <div className="py-2" ref={userDropdownRef}>
                  <button
                    className="flex items-center w-full text-gray-300 hover:text-white transition-colors"
                    onClick={handleToggleUserDropdown}
                  >
                    <FaUserCircle className="w-5 h-5 mr-2" />
                    <span>{firstName}</span>
                    <FaChevronDown className="w-3 h-3 ml-1" />
                  </button>

                  {showUserDropdown && (
                    <div className="mt-2 bg-gray-700  w-full">
                      <div className="p-3 border-b border-gray-600">
                        <div className="flex items-start space-x-3">
                          <FaUserCircle className="w-8 h-8 text-gray-400" />
                          <div>
                            <span className="font-medium text-white">
                              {userProfile.name}
                            </span>
                            <div className="text-sm text-gray-400">
                              {userProfile.role}
                            </div>
                            {userProfile.email && (
                              <div className="text-xs text-gray-400">
                                {userProfile.email}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* {userRole === "asset_manager" && (
                          <Link
                            to="/admin/users"
                            className="block px-3 py-2  text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <div className="flex items-center">
                              <FaUsers className="h-5 w-5 mr-3 text-gray-400" />
                              {t('users.users')}
                            </div>
                          </Link>
                        )} */}

                      <button
                        onClick={() => {
                          setShowChangePasswordModal(true);
                          setIsMobileMenuOpen(false);
                        }}
                        className="w-full block px-3 py-2  text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white text-left"
                      >
                        <div className="flex items-center">
                          <FaCog className="h-5 w-5 mr-3 text-gray-400" />
                          {t("navbar.changePassword")}
                        </div>
                      </button>

                      <button
                        className="w-full flex items-center space-x-3 px-4 py-2 text-left text-gray-300 hover:bg-gray-600 transition-colors"
                        onClick={handleLogout}
                      >
                        <FaSignOutAlt className="w-4 h-4" />
                        <span>{t("navbar.logout")}</span>
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <div className="flex flex-col space-y-2 py-2">
                  <button
                    className="w-full px-4 py-2 bg-transparent border border-blue-500 text-white  hover:bg-blue-500  transition-colors text-center"
                    onClick={() => navigate("/login")}
                  >
                    {t("createAsset.buttons.Login")}
                  </button>
                  <button
                    className="w-full px-4 py-2 bg-blue-500 text-white  hover:bg-blue-600 transition-colors text-center"
                    onClick={() => navigate("/register")}
                  >
                    {t("createAsset.buttons.Signup")}
                  </button>
                </div>
              )}
            </nav>
          )}
        </div>
      </header>

      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        className="z-50"
      />

      {/* Main Content Section */}
      <div className="flex flex-col justify-between min-h-screen bg-gray-900 text-white">
        {/* Hero Section */}
        <div className="flex flex-col items-center text-center px-4 pt-12 sm:pt-16 md:pt-20 lg:pt-32 flex-grow justify-center gap-4">
          <img
            className="h-24 w-auto sm:h-28 md:h-32 object-contain"
            src={lift14Img}
            alt="logo"
          />
          <p className="text-lg sm:text-xl md:text-2xl text-gray-300 max-w-3xl mb-8 leading-relaxed">
            {t("home.manageAssets")}
          </p>


        </div>

        {/* Footer will stay at the bottom */}
        {showChangePasswordModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
              <div className="flex items-center justify-between p-6 border-b border-gray-200">
                <h2 className="text-lg font-semibold text-gray-900">
                  {t("passwordModal.title")}
                </h2>
                <button
                  className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
                  onClick={() => setShowChangePasswordModal(false)}
                >
                  <FaTimes className="w-5 h-5" />
                </button>
              </div>

              <form onSubmit={handleSubmitPasswordChange} className="p-6">
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {t("passwordModal.currentPassword")}
                    </label>
                    <div className="relative">
                      <input
                        type={showOldPassword ? "text" : "password"}
                        name="oldPassword"
                        value={passwordData.oldPassword}
                        onChange={handlePasswordChange}
                        required
                        placeholder={t(
                          "passwordModal.currentPasswordPlaceholder"
                        )}
                        minLength="8"
                        className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      />
                      <button
                        type="button"
                        className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                        onClick={() => setShowOldPassword(!showOldPassword)}
                      >
                        {showOldPassword ? (
                          <FaEyeSlash className="w-4 h-4" />
                        ) : (
                          <FaEye className="w-4 h-4" />
                        )}
                      </button>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {t("passwordModal.newPassword")}
                    </label>
                    <div className="relative">
                      <input
                        type={showNewPassword ? "text" : "password"}
                        name="newPassword"
                        value={passwordData.newPassword}
                        onChange={handlePasswordChange}
                        required
                        placeholder={t("passwordModal.newPasswordPlaceholder")}
                        minLength="8"
                        className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      />
                      <button
                        type="button"
                        className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                        onClick={() => setShowNewPassword(!showNewPassword)}
                      >
                        {showNewPassword ? (
                          <FaEyeSlash className="w-4 h-4" />
                        ) : (
                          <FaEye className="w-4 h-4" />
                        )}
                      </button>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {t("passwordModal.confirmPassword")}
                    </label>
                    <div className="relative">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        name="newPasswordConfirm"
                        value={passwordData.newPasswordConfirm}
                        onChange={handlePasswordChange}
                        required
                        placeholder={t(
                          "passwordModal.confirmPasswordPlaceholder"
                        )}
                        minLength="8"
                        className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      />
                      <button
                        type="button"
                        className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      >
                        {showConfirmPassword ? (
                          <FaEyeSlash className="w-4 h-4" />
                        ) : (
                          <FaEye className="w-4 h-4" />
                        )}
                      </button>
                    </div>
                  </div>
                </div>

                <div className="flex justify-end space-x-3 mt-6">
                  <button
                    type="button"
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    onClick={() => setShowChangePasswordModal(false)}
                    disabled={isChangingPassword}
                  >
                    {t("createAsset.buttons.cancel")}
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                    disabled={isChangingPassword}
                  >
                    {isChangingPassword ? (
                      <>
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2 inline-block"></div>
                        {t("passwordModal.buttons.change")}
                      </>
                    ) : (
                      t("passwordModal.buttons.change")
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
const styles = {
  buttonGroup: {
    display: "flex",
    gap: "0.1px",
    alignItems: "center",
    position: "relative",
    left: "1000px",
  },
  buttonGroup1: {
    display: "flex",
    gap: "0.5rem",
    alignItems: "center",
  },
  loginButton: {
    backgroundColor: "transparent",
    border: "none",
    color: "rgba(255, 255, 255, 0.7)",
    padding: "0.3rem 0.8rem",
    transition: "color 0.3s ease",
    fontSize: "0.8rem",
    position: "fixed",
    right: "120px" /* Adjusted */,
    top: "20px" /* Ensuring alignment */,
  },

  signUpButton: {
    backgroundColor: "transparent",
    border: "none",
    color: "rgba(255, 255, 255, 0.7)",
    padding: "0.3rem 0.8rem",
    transition: "color 0.3s ease",
    fontSize: "0.8rem",
    position: "fixed",
    right: "20px" /* Positioned left of login */,
    top: "20px" /* Same top alignment */,
  },
  loginButton1: {
    backgroundColor: "transparent",
    border: "none",
    color: "rgba(255, 255, 255, 0.7)",
    padding: "0.3rem 0.8rem",
    transition: "color 0.3s ease",
    fontSize: "0.8rem",
  },

  signUpButton1: {
    backgroundColor: "transparent",
    border: "none",
    color: "rgba(255, 255, 255, 0.7)",
    padding: "0.3rem 0.8rem",
    transition: "color 0.3s ease",
    fontSize: "0.8rem",
  },

  heroTitle: {
    fontSize: "3rem",
    fontWeight: "bold",
    marginBottom: "1rem",
  },
  heroSubtitle: {
    fontSize: "1.2rem",
    color: "rgba(255, 255, 255, 0.8)",
    marginBottom: "2rem",
    maxWidth: "600px",
  },
  viewProductsButton: {
    backgroundColor: "rgb(56, 73, 228)",
    border: "none",
    padding: "0.75rem 2rem",
    borderRadius: "1px",
    color: "white",
    fontSize: "1rem",
    width: "fit-content",
  },
};

export default HomePage;
